<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <!-- Loading Screen -->
    <LoadingSpinner v-if="uiStore.isLoading" :show="true" />

    <!-- Main App -->
    <div v-else class="min-h-screen">
      <AppHeader v-if="route.name !== 'login'" />

      <main class="transition-all duration-300 ease-in-out">
        <RouterView />
      </main>
    </div>

    <!-- Custom Notification -->
    <CustomNotification
      :show="notification.show"
      :type="notification.type"
      :title="notification.title"
      :message="notification.message"
      :details="notification.details"
      @close="hideNotification"
    />
  </div>

</template>

<script setup>
import { onMounted } from "vue";
import { RouterView, useRoute } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useUiStore } from "@/stores/ui";
import { useCompanyContextStore } from "@/stores/companyContext";
import { useNotification } from "@/composables/useNotification";
import AppHeader from "@/components/layout/AppHeader.vue";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";
import CustomNotification from "@/components/common/CustomNotification.vue";

const authStore = useAuthStore();
const uiStore = useUiStore();
const companyStore = useCompanyContextStore();
const route = useRoute();
const { notification, hideNotification } = useNotification();

onMounted(async () => {
  uiStore.setLoading(true);

  await authStore.initializeAuth();

  const userRole = authStore.user?.role?.name || authStore.user?.role;

  if (authStore.isAuthenticated && userRole === 'ADMIN') {
    await companyStore.initializeCompanyContext();
  }

  uiStore.setLoading(false);
});
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Inter", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
